import { matchClientByName } from "./matchClientByName";

export function parseBulkClients(rawText, clients) {
    if (!rawText) return [];

    const lines = rawText
        .split("\n")
        .map(l => l.trim())
        .filter(Boolean);

    return lines
        .filter(l => l.toLowerCase().startsWith("cde"))
        .map(line => {
            const rawName = line.replace(/^cde/i, "").trim();
            const match = matchClientByName(rawName, clients);

            return {
                rawName,
                ...match
            };
        });
}
